import React, { useState } from "react"
import { Card, Icon } from "antd"
import { getImageLink } from "../../../../services/asset"
import styles from "./adInfo.scss"
import { parsePriceString } from "../../../../services"
import { Link } from "react-router-dom"
import { AdStatus } from "../../../../models"
import { constructAddress } from "../../../AdDetailsPage/AdDetailsPageWeb/SellerInfo"
import { Chat } from "../../../../typings/interfaces"
import { AdStatusLabel } from "../AdStatusLabel/AdStatusLabel"
import { calculatePriceDiscount } from "../../utils/calculatePriceDiscount"
import { AdCreatedDiff } from "./AdCreatedDiff"

type Props = {
  chat: Chat;
  isMobile: boolean;
}

export const AdInfo = ({
  chat,
  isMobile,
}: Props) => {
  const [isMinimized, setIsMinimized] = useState(false)

  const {
    countryId,
    countryName,
    countyName,
    cityName,
    locationName,
    locationScope,
    adCode,
    adThumbnailUrl,
    adFavoriteCount,
    adCreatedAt,
    adTitle,
    adPrice,
    adStatus,
    adPreviousPrice,
  } = chat;

  // V2OGLASI-2648: wider-area jobs/services ads have no city/county —
  // locationName from BE already carries the human-readable list of
  // picked areas (eg. "Zagreb, Rijeka" or "Cijela Hrvatska").
  const address = locationScope && locationScope !== 1
    ? locationName
    : constructAddress({ countryId, countryName, countyName, cityName })

  return (
    <Card bordered={false} className={styles.adInfoCard}>
      <Icon type="down" className={styles.toggleButton} onClick={() => { setIsMinimized(prev => !prev) }} rotate={!isMinimized && 180} />
      <Link to={`/${adCode}`} target="_blank">
        <div className={styles.adFlexContainer}>
          {!isMinimized && (
            <div className={styles.adImageWrapper} style={{ backgroundImage: `url(${getImageLink(adThumbnailUrl)})` }}>
              {adPreviousPrice && <span className={styles.adPreviousPrice}>-{calculatePriceDiscount(adPreviousPrice, adPrice)}%</span>}
              <AdStatusLabel status={adStatus} />

            </div>
          )}
          <div className={styles.adDescription}>
            <p className={styles.adDescriptionTop}><strong>{adTitle}</strong></p>
            <p className={styles.price}>{parsePriceString(adPrice)}</p>
            {!isMinimized && (
              <React.Fragment>
                {adFavoriteCount > 0 && <p className={styles.descr}><Icon type="heart" /> {adFavoriteCount} korisnik{adFavoriteCount === 1 ? "" : "a"}</p>}
                {adStatus === AdStatus.active && <AdCreatedDiff adCreatedAt={adCreatedAt} />}
                <p className={styles.descr}>{address}</p>
              </React.Fragment>
            )}
          </div>
        </div>
      </Link>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/AdInfo/AdInfo.tsx